import React from "react";

import style from "./style.module.scss";

export function ConnectionStatus({ children }) {
  return <div className={style.connectionStatus}>{children}</div>;
}
